/* Desktop category menu (snippets/header-menu-desktop.liquid).
   One panel open at a time. Mouse: opens on hover, closes shortly after the pointer leaves.
   Touch and pen: the first tap on a top-level link opens its panel, the second follows the link.
   Keyboard: the caret button toggles, Escape closes and returns focus to the button, tabbing
   out of an item closes it. An open panel is shifted horizontally to stay inside the header's content box. */
class HeaderMenu extends HTMLElement {
  connectedCallback() {
    this.closeDelay = 150;
    this.lastPointerType = 'mouse';
    this.items = Array.from(this.querySelectorAll('.category-nav__item')).filter((item) =>
      item.querySelector('.category-nav__panel')
    );

    this.items.forEach((item) => {
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.open(item);
      });
      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.scheduleClose(item);
      });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) this.close(item);
      });
      item.querySelector('.category-nav__toggle').addEventListener('click', () => {
        this.isOpen(item) ? this.close(item) : this.open(item);
      });
      item.querySelector('.category-nav__link').addEventListener('click', (event) => {
        if (this.lastPointerType !== 'mouse' && !this.isOpen(item)) {
          event.preventDefault();
          this.open(item);
        }
      });
    });

    this.addEventListener('pointerdown', (event) => {
      this.lastPointerType = event.pointerType;
    });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const item = event.target.closest('.category-nav__item');
      if (item && this.isOpen(item)) {
        this.close(item);
        item.querySelector('.category-nav__toggle').focus();
      }
    });

    this.onOutsidePointer = (event) => {
      if (!this.contains(event.target)) this.items.forEach((item) => this.close(item));
    };
    document.addEventListener('pointerdown', this.onOutsidePointer);
  }

  disconnectedCallback() {
    document.removeEventListener('pointerdown', this.onOutsidePointer);
  }

  isOpen(item) {
    return item.hasAttribute('data-open');
  }

  open(item) {
    clearTimeout(item.closeTimer);
    this.items.forEach((other) => {
      if (other !== item) this.close(other);
    });
    if (this.isOpen(item)) return;
    item.setAttribute('data-open', '');
    item.querySelector('.category-nav__toggle').setAttribute('aria-expanded', 'true');
    this.keepInsideHeader(item.querySelector('.category-nav__panel'));
  }

  scheduleClose(item) {
    clearTimeout(item.closeTimer);
    item.closeTimer = setTimeout(() => this.close(item), this.closeDelay);
  }

  close(item) {
    clearTimeout(item.closeTimer);
    if (!this.isOpen(item)) return;
    item.removeAttribute('data-open');
    item.querySelector('.category-nav__toggle').setAttribute('aria-expanded', 'false');
  }

  keepInsideHeader(panel) {
    panel.style.removeProperty('--shift');
    const container = this.closest('.page-width') || document.documentElement;
    const box = container.getBoundingClientRect();
    const style = getComputedStyle(container);
    const left = box.left + parseFloat(style.paddingLeft);
    const right = box.right - parseFloat(style.paddingRight);
    const rect = panel.getBoundingClientRect();
    let shift = 0;
    if (rect.right > right) shift = right - rect.right;
    if (rect.left + shift < left) shift = left - rect.left;
    if (shift) panel.style.setProperty('--shift', `${Math.round(shift)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
